module.exports = __webpack_public_path__ + "static/media/camera.00238575.svg";